module.exports = __webpack_public_path__ + "static/media/fr.bd656d19.webp";